import { ReactNode } from 'react';

import { Container, Section } from '@bytel/trilogy-react';

interface SectionContainerProps {
    children: ReactNode;
}

export function SectionContainer({ children }: Readonly<SectionContainerProps>) {
    return (
        <Section>
            <Container size='md'>{children}</Container>
        </Section>
    );
}
